const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the explore search component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('exploreSearch', ['$q', function ($q) {
  return {
    restrict: 'E',
    scope: {
      queries: '=',
      clearSearch: '=',
    },
    template: require('../../templates/directives/explore-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queries = [];
      self.updateQuery = function () {
        $scope.queries = self.queries;
      };

      self.removeUnique = function(type) {
        for (var i = 0; i < self.queries.length; i++) {
          if (self.queries[i].type === 'text') {
            var removed = self.queries.splice(i, 1);
            return;
          }
        }
      };

      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (!$tag.type && $tag.name) {
            $tag.text = $tag.name;
            $tag._id = $tag.name + '-text';
            $tag.type = 'text';
            self.removeUnique($tag.type);
          }
          return true;
        },
        addedTag: function ($tag, outside) {
          self.updateQuery();
        },
        removedTag: function ($tag) {
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.getOptions = function (input) {
        var deferred = $q.defer();

        var options = ['Articles', 'Workshops', 'Videos', 'Files', 'Tracks', 'Learning Tracks', 'Courses', 'Assessments', 'Quizzes', 'Scorm'];
        var typeMap = {
          Articles: 'article',
          Workshops: 'workshop',
          Videos: 'video',
          Files: 'file',
          Tracks: 'track',
          'Learning Tracks': 'track',
          Courses: 'course',
          Scorm: 'scorm'
        };
        var reg = new RegExp(input, 'i');
        var queries = self.queries.map(function(item) {return item.name;});
        var items = options.filter(function(item) {
          return (item.match(reg) && queries.indexOf(item) === -1) ? true : false;
        }).map(function(item) {
          return {
            name: item,
            text: item,
            _id: item,
            type: typeMap[item]
          };
        });

        deferred.resolve(items);

        return deferred.promise;
      };
      $scope.$watch('clearSearch', function(newVal, oldVal) {
        if (newVal && !oldVal && self.queries.length) {
          self.queries.splice(0);
          $scope.clearSearch = false;
        }
      });

    }],
    controllerAs: 'exploreSearch'
  };
}]);